import { Detailed } from "@react-three/drei";
import { FC, PropsWithChildren } from "react";

export const LOD_DISTANCES = [0, 15, 30];

export const LOD: FC<PropsWithChildren> = ({ children }) => (
  // @ts-expect-error
  <Detailed distances={LOD_DISTANCES}>{children}</Detailed>
);
